import { createReducer, on } from '@ngrx/store';
import { initialAuthState } from './auth.state';
import * as AuthActions from './auth.actions';

export const authReducer = createReducer(
  initialAuthState,

  // Login
  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
    error: null
  })),

  on(
    AuthActions.loginSuccess,
    AuthActions.hydrateAuthSuccess,
    (state, { token, userId, userEmail, userRoles }) => ({
      ...state,
      isAuthenticated: true,
      token,
      userId,
      userEmail,
      userRoles,
      loading: false,
      error: null,
    }),
  ),

  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    isAuthenticated: false,
    loading: false,
    error
  })),

  // Logout
  on(AuthActions.logout, (state) => ({
    ...state,
    loading: true
  })),

  on(AuthActions.logoutSuccess, () => initialAuthState),

  // Clear Error
  on(AuthActions.clearError, (state) => ({
    ...state,
    error: null
  })),

  // Load from Storage
  on(AuthActions.loadAuthFromStorage, (state) => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Could decode token here to get user info if needed
        return {
          ...state,
          isAuthenticated: true,
          token
        };
      } catch {
        return state;
      }
    }
    return state;
  }),

  // Reset Password
  on(AuthActions.resetPassword, (state) => ({
    ...state,
    resetPasswordLoading: true,
    resetPasswordError: null,
    resetPasswordSuccess: false
  })),

  on(AuthActions.resetPasswordSuccess, (state) => ({
    ...state,
    resetPasswordLoading: false,
    resetPasswordError: null,
    resetPasswordSuccess: true
  })),

  on(AuthActions.resetPasswordFailure, (state, { error }) => ({
    ...state,
    resetPasswordLoading: false,
    resetPasswordError: error,
    resetPasswordSuccess: false
  })),

  on(AuthActions.clearResetPasswordError, (state) => ({
    ...state,
    resetPasswordError: null
  })),

  on(AuthActions.clearResetPasswordSuccess, (state) => ({
    ...state,
    resetPasswordSuccess: false
  })),

  on(AuthActions.hydrateAuthFailure, (state, { error }) => ({
    ...state,
    isAuthenticated: false,
    token: null,
    userId: null,
    userEmail: null,
    userRoles: [],
    loading: false,
    error: error ?? null
  })),

  on(AuthActions.resetLogin, (state) => ({
    ...state,
    ...initialAuthState
  }))
);

